// store/selectedTagSlice.js
import { createSlice } from '@reduxjs/toolkit';

const selectedTagSlice = createSlice({
  name: 'selectedTag',
  initialState: {
    selectedSuperTag: 'All',
  },
  reducers: {
    setSelectedSuperTag: (state, action) => {
      state.selectedSuperTag = action.payload;
    },
  },
});

export const { setSelectedSuperTag } = selectedTagSlice.actions;
export default selectedTagSlice.reducer;
